import { ZodIssueCode } from 'zod'

export const validationErrors = {
  ...ZodIssueCode,
  required: 'required',
  too_small_date: 'too_small_date',
  invalid_postal_code: 'invalid_postal_code',
  invalid_number: 'invalid_number',
  invalid_iban: 'invalid_iban',
  invalid_bic: 'invalid_bic',
  bic_country_mismatch: 'bic_country_mismatch',
  bank_country_mismatch: 'bank_country_mismatch',
  invalid_email: 'invalid_email',
  invalid_phone_number: 'invalid_phone_number',
  invalid_ssn: 'invalid_ssn',
  invalid_string: 'invalid_string',
  invalid_pin: 'invalid_pin',
  too_big_date: 'too big date',
  move_date_after_end_date: 'move_date_after_end_date',
  invalid_return_percentage_sum: 'invalid_return_percentage_sum',
  invalid_roo_return_percentage_sum: 'invalid_roo_return_percentage_sum',
  title_description_or_files_required: 'title_description_or_files_required',
  no_resident_user: 'no_resident_user',
  terminated_adult_missing_resident_user:
    'terminated_adult_missing_resident_user',
  no_adult_left: 'no_adult_left',
  other_contract_party_termination: 'other_contract_party_termination',
} as const
